import { render, staticRenderFns } from "./signer-lookup.vue?vue&type=template&id=c154bde0&"
import script from "./signer-lookup.vue?vue&type=script&lang=ts&"
export * from "./signer-lookup.vue?vue&type=script&lang=ts&"
import style0 from "./signer-lookup.vue?vue&type=style&index=0&id=c154bde0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports